class CarouselComparison extends HTMLElement {
  constructor() {
    super();
    this.handle = null;
    this.resizeElement = null;
  }

  connectedCallback() {
    this.initSlider();
    window.addEventListener('resize', this.updateSliders.bind(this));
  }

  initSlider() {
    this.handle = this.querySelector('.carousel-comparison__handle');
    this.resizeElement = this.querySelector('.carousel-comparison__resize');
    this.adjustSlider();
    this.initDrags();
  }

  adjustSlider() {
    const width = this.offsetWidth + 'px';
    this.resizeElement.querySelector('img').style.width = width;
  }

  updateSliders() {
    this.adjustSlider();
  }

  initDrags() {
    const dragElement = this.handle;
    const resizeElement = this.resizeElement;
    const container = this;

    dragElement.addEventListener('mousedown', startDrag);
    dragElement.addEventListener('touchstart', startDrag);

    function startDrag(e) {
      dragElement.classList.add('draggable');
      resizeElement.classList.add('resizable');

      const startX = e.pageX || e.touches[0].pageX;
      const dragWidth = dragElement.offsetWidth;
      const posX = dragElement.offsetLeft + dragWidth - startX;
      const containerOffset = container.offsetLeft;
      const containerWidth = container.offsetWidth;

      const minLeft = containerOffset + 15;
      const maxLeft = containerOffset + containerWidth - dragWidth - 15;

      function moveDrag(e) {
        const moveX = e.pageX || e.touches[0].pageX;
        let leftValue = moveX + posX - dragWidth;

        if (leftValue < minLeft) {
          leftValue = minLeft;
        } else if (leftValue > maxLeft) {
          leftValue = maxLeft;
        }

        const widthValue = ((leftValue + dragWidth / 2 - containerOffset) * 100) / containerWidth + '%';

        dragElement.style.left = widthValue;
        resizeElement.style.width = widthValue;

        dragElement.addEventListener('mouseup', stopDrag);
        dragElement.addEventListener('touchend', stopDrag);
        dragElement.addEventListener('touchcancel', stopDrag);
      }

      function stopDrag() {
        dragElement.classList.remove('draggable');
        resizeElement.classList.remove('resizable');
        container.removeEventListener('mousemove', moveDrag);
        container.removeEventListener('touchmove', moveDrag);
      }

      container.addEventListener('mousemove', moveDrag);
      container.addEventListener('touchmove', moveDrag);
      e.preventDefault();
    }
  }
}

customElements.define('carousel-comparison', CarouselComparison);
